var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "server-qa" }, [
    _c("div", { staticClass: "tabs flex" }, [
      _c(
        "div",
        {
          staticClass: "tab-item",
          class: { active: _vm.active === 2 },
          on: {
            click: function($event) {
              _vm.active = 2
            }
          }
        },
        [_vm._v("法律问题")]
      ),
      _c(
        "div",
        {
          staticClass: "tab-item",
          class: { active: _vm.active === 1 },
          on: {
            click: function($event) {
              _vm.active = 1
            }
          }
        },
        [_vm._v("售后问题")]
      )
    ]),
    _c("div", { staticClass: "ques-wrapper" }, [
      _c(
        "div",
        { staticClass: "content" },
        _vm._l(_vm.getData, function(item, index) {
          return _c("other-customer-question-item", {
            key: index,
            attrs: { data: item }
          })
        }),
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }